import { render, staticRenderFns } from "./PurchaseDetails.vue?vue&type=template&id=426131f5&scoped=true&"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426131f5",
  null
  
)

export default component.exports